import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import PropertySuggestion, { PropertySuggestionsError } from '@lib/hundredBricksAPI/properties/propertySuggestion/PropertySuggestion';
class PropertySuggestionsAPI extends HundredBricksAPI {
    async getPropertySuggestions() {
        try {
            const { data } = await this.client.get('v2/propertySuggestions');
            return data.items.map((item) => new PropertySuggestion(item));
        }
        catch (error) {
            if (error instanceof APIError) {
                throw new PropertySuggestionsError({ cause: error });
            }
            else if (error instanceof Error) {
                throw new PropertySuggestionsError('Unexpected property suggestion error', {
                    cause: error
                });
            }
            else {
                throw new PropertySuggestionsError(`Unexpected property suggestion error: '${error}'`);
            }
        }
    }
}
export default PropertySuggestionsAPI;
